@if (!isInEditor) {
  <be-resize-drawer />
}
<button
  #closeButton
  class="close-dialog"
  (mousedown)="closeDrawer($event)"
  data-cy="DrawerElement:close"
>
  <mat-icon svgIcon="icon_close_16" />
</button>
<div
  class="content close-affordance"
  [ngStyle]="contentStyle"
  [blazeSlotNode]="slots?.slotNodesData?.content"
>
  <ng-container
    *ngTemplateOutlet="
      slots?.templates?.content || null;
      context: { elementContext: { viewType: 'drawer' } }
    "
  />
</div>
